"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.default = (function (_a) {
    var _b = _a.height, height = _b === void 0 ? 20 : _b, _c = _a.width, width = _c === void 0 ? 20 : _c;
    return (react_1.default.createElement("i", null,
        react_1.default.createElement("svg", { width: width, height: height, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M4.583 14.894l-3.256 3.78c-.7.813-1.26.598-1.25-.46a10689.413 10689.413 0 0 1 .035-4.775V4.816a3.89 3.89 0 0 1 3.88-3.89h12.064a3.885 3.885 0 0 1 3.882 3.89v6.185a3.89 3.89 0 0 1-3.882 3.89H4.583z", fill: "#FFF", fillRule: "evenodd" }))));
});
